import React from 'react'
import { MarketViewSearchResult } from '../../services/api'
import ScoreRadarChart from './ScoreRadarChart'
import { Building2 } from 'lucide-react'

interface TradeoffTooltipProps {
  result: MarketViewSearchResult
  position: { x: number, y: number }
}

const TradeoffTooltip: React.FC<TradeoffTooltipProps> = ({ result, position }) => {
  const { product, vendor, scores } = result
  const imageUrl = product.primary_image?.image_url || product.image_url

  return (
    <div 
      className="absolute z-50 bg-card border-2 border-primary rounded-lg shadow-xl p-4 pointer-events-none"
      style={{
        left: position.x + 20,
        top: position.y - 100,
        width: '320px'
      }}
    >
      {/* Product Image */}
      <div className="h-32 bg-muted rounded mb-3">
        {imageUrl ? (
          <img src={imageUrl} alt={product.name} className="w-full h-full object-cover rounded" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Building2 className="w-12 h-12 text-muted-foreground/30" />
          </div>
        )}
      </div>

      {/* Product Info */}
      <h4 className="font-semibold text-sm mb-1">{product.name}</h4>
      <p className="text-xs text-muted-foreground mb-3">{vendor.name}</p>

      {/* Description */}
      <p className="text-xs text-muted-foreground line-clamp-3 mb-3">
        {product.description || 'No description available'}
      </p>

      {/* Radar Chart */}
      <div className="flex justify-center">
        <ScoreRadarChart scores={scores} size={120} />
      </div>
    </div>
  )
}

export default TradeoffTooltip
